import axios from 'axios'
import requests from '@/services/api/api'

const getLoginModuleData = async function(){
    try {
        return await axios.get(requests.GET_LOGIN_MODULE_DATA)
    } catch (error) {
        return error
    }
}

export { getLoginModuleData }